module.exports = __webpack_public_path__ + "img/INMUEBLES.8e02a380.jpeg";